export default {
  hompagePanelMobile: '10rem',
  homepagePanelDesktop: '22.5rem'
}
